import React, { useState, useEffect } from 'react';
import AccediForm from '../../components/Forms/AccediForm/AccediForm';
import CompleteProfileForm from '../../components/Forms/CompleteProfileForm/CompleteProfileForm';
// NUOVO: Importo useLocation per leggere i parametri
import { useLocation } from 'react-router-dom';

const AccediPage = () => {
  const [completeProfile, setCompleteProfile] = useState(null);
  
  // --- CORREZIONE: Logica per gestire id_sp ---
  const location = useLocation();
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const idSP = params.get("id_sp");
    
    // Se trovo id_sp nell'URL della pagina di accesso/registrazione,
    // lo salvo in localStorage. Sarà usato da AccediForm dopo il login.
    if (idSP) {
      localStorage.setItem("idSP", idSP);
    }
    // Non lo rimuovo qui, perché mi serve che persista durante il processo.
    // Verrà rimosso da CorsiPage quando si tornerà alla vetrina principale.
  }, [location.search]);
  // ---------------------------------------------

  const handlecompleteProfile = (data) => {
    if(data?.username) {
      setCompleteProfile(data);
    } else {
      setCompleteProfile(null);
    }
  };

  return (
    <div className='my-5'>
      {
        !completeProfile?.username ?
        <AccediForm fetchCompleteProfile={handlecompleteProfile}/>
        :
        <CompleteProfileForm fetchCompleteProfile={completeProfile} setCompleteProfile={setCompleteProfile}/>
      }
    </div>
  );
};

export default AccediPage;
